import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'secondsFromNow',
    standalone: false,
    pure: false
})
export class SecondsFromNowPipe implements PipeTransform {
    transform(value: string | Date | null | undefined): number {
        if (!value) {
            return Number.POSITIVE_INFINITY;
        }

        const inputTime = moment.utc(value);

        if (!inputTime.isValid()) {
            return Number.POSITIVE_INFINITY;
        }

        return Math.max(0, moment.utc().diff(inputTime, 'seconds'));
    }
}
